var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { getProps, Router } from "../components/router";
export var createRoot = function (Application) { return function (props) {
    return (React.createElement(Router, __assign({}, getProps(props)),
        React.createElement(Application, __assign({}, props))));
}; };



//////////////////
// WEBPACK FOOTER
// ./app/shared/utils/createRoot.tsx
// module id = Ahhh
// module chunks = 2 3 4